import React, {useContext, useEffect, useState} from "react";
import {Button, Col, Row, Select} from "antd";
import {AppContext} from "../../contexts/app-context";
import InputField from "../input-field";

import i18n from "../../i18n";

export default function SearchFilter() {
  const {Option} = Select;
  const appContext = useContext(AppContext);
  const [clearFilterFlag, setClearFilterFlag] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);
  const [searchString, setSearchString] = useState(appContext.filter.searchString || '');
  const [selectedSorting, setSelectedSorting] = useState(appContext.filter.selectedSorting);
  const isEmptyFilter = !searchString;

  const onChangeFilterSort = (value) => {
    setSelectedSorting(value);
  };

  useEffect(() => {
    if ((!isFiltered && !isEmptyFilter) || clearFilterFlag) {
      appContext.applySearchString(searchString);
      if (!isFiltered && !isEmptyFilter) {
        setIsFiltered(true);
        setClearFilterFlag(true);
      }
    }
  }, [isFiltered, clearFilterFlag]);

  const applyFilterParams = () => {
    appContext.applySearchString(searchString);
    appContext.setIsNeedUpdateUnloadingList(true);

    if (!isEmptyFilter) {
      setIsFiltered(true);
      setClearFilterFlag(true);
    }
  };

  const clearFilterParams = () => {
    if (isFiltered) {
      setIsFiltered(false);
    }
  };

  const sortItems = appContext.filter.sort;

  return (
    <div className="filters-container">
      <div className="container">
        <div className="filters-container__wrapper">
          <Row gutter={22} style={{padding: "0", margin: "0", rowGap: "10px"}} type="flex" justify="start">
            <Col xs={24} sm={24} md={16} lg={16} xl={16}>
              <InputField
                style={{height: '100%'}}
                name="fullName"
                title={i18n.t('constants.formFields.FullName')}
                placeholder="Поиск"
                size="large"
                value={searchString}
                setValue={
                  (value) => {setSearchString(value)}
                }
                getFieldErrors={() => {}}
              />
            </Col>
            <Col xs={12} sm={12} md={5} lg={5} xl={5} style={{}}>
              <Select
                size="default"
                onChange={(value) => {
                  onChangeFilterSort(value);
                }}
                defaultValue={selectedSorting}
                value={selectedSorting}
                style={{width: "100%", height: "100%"}}
              >
                {sortItems.map((sortItem) => {
                  return (
                    <Option key={sortItem.name} value={sortItem.name} selected={sortItem.selected}>
                      {sortItem.title}
                    </Option>
                  );
                })}
              </Select>
            </Col>
            <Col className="filters-buttons" xs={12} sm={12} md={3} lg={3} xl={3} style={{}}>
              <Button
                className="filters-button"
                type="primary"
                size="default"
                icon="search"
                htmlType="button"
                title={i18n.t('components.filter.buttons.apply')}
                onClick={applyFilterParams}
              />
              <Button
                className="filters-button filters-button--clear"
                type="primary"
                size="default"
                icon="close"
                disabled={isEmptyFilter}
                htmlType="button"
                title={i18n.t('components.filter.buttons.clear')}
                style={{border: "none", outline: "none", marginLeft: "5px"}}
                onClick={clearFilterParams}
              />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
